//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// eslint-disable-next-line object-curly-newline
import {
  mdiFilePdfBox,
  mdiClockOutline,
  mdiMessageTextOutline,
  mdiPhone,
  mdiCartOutline,
  mdiFileEditOutline,
  mdiAirplane,
  mdiArrowRight,
  mdiServer,
  mdiWeb,
  mdiCpu64Bit,
  mdiMemory,
  mdiShareVariantOutline,
  mdiReload,
  mdiMapMarkerOutline,
  mdiLinkVariant,
  mdiAccountOutline,
} from '@mdi/js'

export default {
  setup() {
    return {
      icons: {
        mdiAirplane,
        mdiFilePdfBox,
        mdiClockOutline,
        mdiMessageTextOutline,
        mdiPhone,
        mdiCartOutline,
        mdiFileEditOutline,
        mdiArrowRight,
        mdiServer,
        mdiWeb,
        mdiCpu64Bit,
        mdiMemory,
        mdiShareVariantOutline,
        mdiReload,
        mdiMapMarkerOutline,
        mdiLinkVariant,
        mdiAccountOutline,
      },
    }
  },
}
